/**
 * Created by lior on 12/4/14.
 */

'use strict';

var _ = require('underscore');
var SoaModel = require('bunsen/models/SoaModel');
var PaymentProviderResponse = module.exports = SoaModel.extend();

var propEquals = function (propName, value) {
    return this.get(propName) === value;
};

_.extend(PaymentProviderResponse, {
    STATUS_SUCCESS: 'SUCCESS',
    STATUS_DATA_ERROR: 'DATA_ERROR',
    STATUS_PROCESSOR_ERROR: 'PROCESSOR_ERROR',
    ACTION_RESERVE: 'RESERVE',
    ACTION_CAPTURE: 'CAPTURE',
    ACTION_VAULT: 'VAULT_TRANSACTION'
});

_.extend(PaymentProviderResponse.prototype, {
    getErrorStatus: function () {
        return this.get('status');
    },
    isDataError: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_DATA_ERROR),
    isProcessorError: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_PROCESSOR_ERROR),
    isSuccess: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_SUCCESS),
    isReserveTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_RESERVE),
    isCaptureTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_CAPTURE),
    isVaultTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_VAULT)
});




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/PaymentProviderResponse.js
// module id = 174
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54